<script>
    import { onMount } from "svelte";
    import About from "./routes/About.svelte";
    import Chat from "./routes/Chat.svelte";
    import Login from "./routes/Login.svelte";
    import Signup from "./routes/Signup.svelte";

    var authenticated = false;
    var showRegister = false;
    var username = "";
    let showLogin = false;
    let showAbout = false;
    let showChat = false;
    let loginStatus = "";
    let registrationStatus = "";
    let showMenu = false;
    let isDarkMode = true;

    onMount(async () => {
        try {
            // First check if username cookie exists
            const username_cookie = getCookie("username");

            if (username_cookie) {
                // If username cookie exists, set authenticated to true and username
                authenticated = true;
                username = username_cookie;
                showPage("chat");
                return;
            }

            // If no username cookie, proceed with the fetch request
            const response = await fetch("/", {
                method: "GET",
                mode: "cors",
                credentials: "include",
            });
            authenticated = username_cookie;
            showPage("about");
        } catch (error) {
            console.error(error);
            showPage("login");
        }
    });

    // Function to get cookie value by name
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null;
    }

    async function logout() {
        try {
            const response = await fetch("/logout", {
                method: "POST",
                mode: "cors",
                headers: { "Content-Type": "text/plain" },
                body: JSON.stringify({ username }),
                credentials: "include",
            });

            // Clear authentication state regardless of response
            authenticated = false;
            username = "";
            showPage("about");
        } catch (error) {
            console.error("Logout failed:", error);
            // Still reset authentication state and redirect on error
            authenticated = false;
            username = "";
            showPage("login");
        }
    }

    function showPage(page) {
        showLogin = page === "login";
        showRegister = page === "signup";
        showAbout = page === "about";
        showChat = page === "chat";
    }

    function handleLoginStatusChange(event) {
        loginStatus = event.detail.loginStatus;
        if (loginStatus === "Login successful") {
            authenticated = true;
            username = event.detail.username;
            console.log("login: ", event.detail);
            showPage("chat");
        }
    }

    function handleUsernameChange(event) {
        username = event.detail.username;
    }

    function handleRegistrationStatusChange(event) {
        registrationStatus = event.detail.registrationStatus;
        if (registrationStatus === "Sign-up successful") {
            authenticated = true;
            username = event.detail.username;
            console.log("signup: ", event.detail);
            showPage("chat");
        }
    }

    function toggleMenu() {
        showMenu = !showMenu;
    }

    function toggleTheme() {
        isDarkMode = !isDarkMode;
        document.body.classList.toggle("light-mode");
    }
</script>

<main>
    <nav class="top-nav">
        <a href="/" class="logo">nkisin</a>
        <div class="auth-nav">
            <div class="theme-toggle">
                <button class="theme-toggle-button" on:click={toggleTheme}>
                    {#if isDarkMode}
                        <svg
                            class="sun-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                            />
                        </svg>
                    {:else}
                        <svg
                            class="moon-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                            />
                        </svg>
                    {/if}
                </button>
            </div>

            {#if authenticated}
                <span class="username-display">Hi, {username}</span>
                {#if !showChat}
                    <button
                        class="auth-nav-button"
                        on:click={() => showPage("chat")}>Chat</button
                    >
                {/if}
                {#if !showAbout}
                    <button
                        class="auth-nav-button"
                        on:click={() => showPage("about")}>About</button
                    >
                {/if}
                <button class="auth-nav-button logout-button" on:click={logout}
                    >Logout</button
                >
            {:else}
                <button
                    class="auth-nav-button"
                    on:click={() => showPage("login")}>Login</button
                >
                <button
                    class="auth-nav-button"
                    on:click={() => showPage("signup")}>Sign Up</button
                >
            {/if}
        </div>
    </nav>

    {#if !authenticated}
        <div class="homepage">
            {#if showLogin}
                <Login
                    on:loginStatusChange={handleLoginStatusChange}
                    on:usernameChange={handleUsernameChange}
                />
            {:else if showRegister}
                <Signup
                    on:registrationStatusChange={handleRegistrationStatusChange}
                    on:usernameChange={handleUsernameChange}
                />
            {:else}
                <section class="hero-section">
                    <h1 class="small-heading">Hi, my name is</h1>
                    <h2 class="big-heading">Nathan.</h2>
                    <h3 class="sub-heading"></h3>
                    <p class="description"></p>
                </section>

                <!-- <section class="section">
                    <h2 class="section-title">Some Things I've Built</h2>
                    <div class="projects-grid">
                        <div class="project-card">
                            <h3>Featured Project</h3>
                            <p>
                                A brief description of your featured project
                                goes here.
                            </p>
                            <div class="project-links">
                                <a href="/#">GitHub</a>
                                <a href="/#">Live Demo</a>
                            </div>
                        </div>
                        <div class="project-card">
                            <h3>Another Cool Project</h3>
                            <p>
                                A brief description of another cool project goes
                                here.
                            </p>
                            <div class="project-links">
                                <a href="/#">GitHub</a>
                                <a href="/#">Live Demo</a>
                            </div>
                        </div>
                    </div>
                </section> -->
            {/if}
        </div>
    {:else}
        <div class="container">
            <div class="content">
                {#if showChat}
                    <Chat />
                {:else if showAbout}
                    <About />
                {/if}
            </div>
        </div>
    {/if}
</main>

<style>
    :global(body) {
        margin: 0;
        padding: 0;
        font-family: "Inter", sans-serif;
        background-color: #0a192f;
        color: #8892b0;
        transition: all 0.3s ease;
        overflow-x: hidden; /* Prevent horizontal scrolling */
        width: 100%;
        box-sizing: border-box;
    }

    .top-nav {
        position: fixed;
        top: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 2rem;
        box-sizing: border-box;
        background: rgba(10, 25, 47, 0.85);
        backdrop-filter: blur(10px);
        z-index: 10;
    }

    .logo {
        color: #64ffda;
        font-size: 1.5rem;
        font-weight: bold;
        text-decoration: none;
    }

    .auth-nav {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-right: 1rem;
    }

    .auth-nav-button {
        padding: 0.75rem 1.5rem;
        white-space: nowrap;
        background-color: transparent;
        border: 1px solid #64ffda;
        border-radius: 4px;
        color: #64ffda;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .auth-nav-button:hover {
        background-color: rgba(100, 255, 218, 0.1);
    }

    .homepage {
        max-width: 1000px;
        margin: 0 auto;
        padding: 100px 2rem 2rem 2rem;
        width: 100%;
        box-sizing: border-box;
    }

    .hero-section {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .small-heading {
        color: #64ffda;
        font-size: 1rem;
        margin-bottom: 1rem;
    }

    .big-heading {
        color: #ccd6f6;
        font-size: 4rem;
        margin: 0;
        font-weight: bold;
    }

    .sub-heading {
        color: #8892b0;
        font-size: 3rem;
        margin: 0.5rem 0 2rem 0;
        font-weight: bold;
    }

    .description {
        max-width: 540px;
        font-size: 1.2rem;
        line-height: 1.6;
        margin-bottom: 3rem;
        word-wrap: break-word;
    }

    .section {
        margin: 100px 0;
    }

    .section-title {
        color: #ccd6f6;
        font-size: 2rem;
        margin-bottom: 2rem;
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .section-title::after {
        content: "";
        display: block;
        height: 1px;
        width: 300px;
        background-color: #233554;
    }

    .projects-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 2rem;
    }

    .project-card {
        background-color: #112240;
        padding: 2rem;
        border-radius: 4px;
        transition: transform 0.3s ease;
    }

    .project-card:hover {
        transform: translateY(-5px);
    }

    .project-card h3 {
        color: #ccd6f6;
        margin: 0 0 1rem 0;
    }

    .project-links {
        margin-top: 1rem;
        display: flex;
        gap: 1rem;
    }

    .project-links a {
        color: #64ffda;
        text-decoration: none;
    }

    @media (max-width: 768px) {
        .top-nav {
            padding: 0.75rem 1rem;
        }

        .big-heading {
            font-size: 2.5rem;
            word-wrap: break-word;
        }

        .sub-heading {
            font-size: 2rem;
            word-wrap: break-word;
        }

        .section-title::after {
            width: 100px;
        }

        .auth-nav {
            gap: 0.5rem;
            margin-right: 0;
        }

        .auth-nav-button {
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
        }

        .description {
            font-size: 1rem;
            max-width: 100%;
            word-wrap: break-word;
        }

        .homepage {
            padding: 80px 1.5rem 1.5rem 1.5rem;
        }
    }

    @media (max-width: 480px) {
        .top-nav {
            padding: 0.5rem 0.75rem;
            flex-wrap: wrap;
            justify-content: space-between;
        }

        .auth-nav {
            gap: 0.25rem;
            flex-wrap: wrap;
            justify-content: flex-end;
        }

        .logo {
            font-size: 1.2rem;
        }

        .username-display {
            font-size: 0.8rem;
            margin-right: 0.5rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 80px;
        }

        .big-heading {
            font-size: 2rem;
            word-wrap: break-word;
        }

        .sub-heading {
            font-size: 1.5rem;
            word-wrap: break-word;
        }

        .description {
            font-size: 0.9rem;
            line-height: 1.5;
            word-wrap: break-word;
        }

        .homepage {
            padding: 70px 1rem 1rem 1rem;
        }

        .auth-nav-button {
            padding: 0.4rem 0.8rem;
            font-size: 0.8rem;
            min-width: 60px;
            margin-bottom: 0.25rem;
        }

        .theme-toggle-button {
            padding: 0.3rem;
        }

        .sun-icon,
        .moon-icon {
            width: 16px;
            height: 16px;
        }

        /* Handle very small screens */
        @media (max-width: 350px) {
            .auth-nav {
                width: 100%;
                justify-content: flex-end;
                margin-top: 0.5rem;
            }

            .top-nav {
                flex-direction: column;
                align-items: flex-start;
            }

            .auth-nav-button {
                padding: 0.3rem 0.6rem;
                font-size: 0.75rem;
            }
        }
    }

    nav {
        width: 200px;
        background-color: #f4f4f4;
        padding: 1rem;
    }

    ul {
        list-style: none;
        padding: 0;
    }

    li {
        margin: 1rem 0;
    }

    a {
        text-decoration: none;
        color: #333;
    }

    .container {
        display: flex;
        width: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
    }

    .content {
        flex: 1;
        padding: 1rem;
        margin-top: 60px;
        width: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
    }

    @media (max-width: 480px) {
        .content {
            margin-top: 50px;
            padding: 0.75rem;
        }

        :global(form input) {
            padding: 0.6rem;
            font-size: 0.9rem;
        }

        :global(form button) {
            padding: 0.6rem;
            font-size: 0.9rem;
        }
    }

    .hamburger {
        display: none;
        cursor: pointer;
    }

    .hamburger div {
        width: 25px;
        height: 3px;
        background-color: #333;
        margin: 5px 0;
    }

    .hidden {
        display: none;
    }

    @media (max-width: 600px) {
        nav {
            display: none;
        }

        nav.show {
            display: block;
        }

        .hamburger {
            display: block;
        }
    }

    @media (min-width: 601px) {
        .hamburger {
            display: none;
        }

        nav {
            display: block;
        }
    }

    b {
        color: #ffffff;
    }

    :global(body.light-mode) {
        background-color: #ffffff;
        color: #333333;
    }

    :global(body.light-mode) .top-nav {
        background-color: rgba(255, 255, 255, 0.85);
    }

    :global(body.light-mode) .logo {
        color: #2d5a27;
    }

    :global(body.light-mode) .auth-nav-button {
        border-color: #2d5a27;
        color: #2d5a27;
    }

    :global(body.light-mode) .project-card {
        background-color: #f5f5f5;
    }

    :global(body.light-mode) .big-heading {
        color: #2d5a27;
    }

    :global(body.light-mode) .small-heading {
        color: #2d5a27;
    }

    :global(body.light-mode) .sub-heading {
        color: #2d5a27;
    }

    :global(body.light-mode) .description {
        color: #2d5a27;
    }

    .theme-toggle {
        display: flex;
        align-items: center;
        margin-right: 1rem;
    }

    .theme-toggle-button {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0.5rem;
        color: #64ffda;
        font-size: 1.2rem;
        display: flex;
        align-items: center;
        transition: transform 0.3s ease;
    }

    .theme-toggle-button:hover {
        transform: scale(1.1);
    }

    :global(body.light-mode) .theme-toggle-button {
        color: #2d5a27;
    }

    /* Sun and Moon icons */
    .sun-icon,
    .moon-icon {
        width: 20px;
        height: 20px;
    }

    .username-display {
        color: #64ffda;
        margin-right: 1rem;
    }

    :global(body.light-mode) .username-display {
        color: #2d5a27;
    }

    .authenticated {
        position: fixed;
        top: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 2rem;
        box-sizing: border-box;
        background: rgba(10, 25, 47, 0.85);
        backdrop-filter: blur(10px);
        z-index: 10;
    }

    @media (max-width: 768px) {
        .authenticated {
            padding: 0.75rem 1rem;
        }
    }

    @media (max-width: 480px) {
        .authenticated {
            padding: 0.5rem 0.75rem;
        }
    }

    :global(body.light-mode) .authenticated {
        background-color: rgba(255, 255, 255, 0.85);
    }

    .logout-button:hover {
        background-color: rgba(100, 255, 218, 0.1);
    }

    :global(body.light-mode) .logout-button:hover {
        background-color: rgba(45, 90, 39, 0.1);
    }

    /* Forms styling for Login and Signup */
    :global(form) {
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
    }

    :global(form input) {
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 1rem;
        padding: 0.75rem;
    }

    :global(form button) {
        width: 100%;
        box-sizing: border-box;
    }

    @media (max-width: 480px) {
        .content {
            margin-top: 50px;
            padding: 0.75rem;
        }

        :global(form input) {
            padding: 0.6rem;
            font-size: 0.9rem;
        }

        :global(form button) {
            padding: 0.6rem;
            font-size: 0.9rem;
        }
    }
</style>
